<template>
  <div class="profile-info">
    <div class="profile-info__avatar"></div>
    <div class="profile-info__full_name">{{ userData.full_name }}</div>
    <div class="profile-info__logout" @click="logout">
      <div class="profile-info__logout-text">
        {{ $t("profile_info.logout") }}
      </div>
      <div class="profile-info__logout-icon">
        <svg
          width="13"
          height="12"
          viewBox="0 0 13 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2_825)">
            <path
              d="M11.8171 5.62522H7.06725C6.86025 5.62522 6.69226 5.45723 6.69226 5.25023C6.69226 5.04324 6.86025 4.87524 7.06725 4.87524H11.8171C12.0241 4.87524 12.1921 5.04324 12.1921 5.25023C12.1921 5.45723 12.0241 5.62522 11.8171 5.62522Z"
              fill="#F27272"
            />
            <path
              d="M9.94216 7.50013C9.84612 7.50013 9.75018 7.4636 9.67712 7.39018C9.53064 7.24361 9.53064 7.00613 9.67712 6.85965L11.2871 5.24975L9.67712 3.63976C9.53064 3.49328 9.53064 3.2558 9.67712 3.10932C9.82369 2.96275 10.0612 2.96275 10.2077 3.10932L12.0826 4.98426C12.2291 5.13074 12.2291 5.36822 12.0826 5.51469L10.2077 7.38963C10.1341 7.4636 10.0382 7.50013 9.94216 7.50013Z"
              fill="#F27272"
            />
            <path
              d="M4.19238 12.0004C4.08536 12.0004 3.98383 11.9853 3.88239 11.9539L0.873422 10.9514C0.464011 10.8084 0.192474 10.4269 0.192474 10.0005V1.00073C0.192474 0.449235 0.640977 0.000732422 1.19247 0.000732422C1.2994 0.000732422 1.40093 0.0157466 1.50246 0.0472398L4.51134 1.04971C4.92084 1.19271 5.19229 1.5742 5.19229 2.00064V11.0004C5.19229 11.5519 4.74388 12.0004 4.19238 12.0004ZM1.19247 0.750709C1.05497 0.750709 0.942451 0.863224 0.942451 1.00073V10.0005C0.942451 10.1069 1.01395 10.2059 1.11594 10.2414L4.11081 11.2394C4.13232 11.2464 4.16034 11.2504 4.19238 11.2504C4.32989 11.2504 4.44231 11.1379 4.44231 11.0004V2.00064C4.44231 1.89417 4.37081 1.7952 4.26882 1.75968L1.27395 0.761695C1.25244 0.754737 1.22442 0.750709 1.19247 0.750709Z"
              fill="#F27272"
            />
            <path
              d="M7.81723 4.00027C7.61023 4.00027 7.44224 3.83228 7.44224 3.62528V1.37535C7.44224 1.03085 7.16182 0.750343 6.81732 0.750343H1.19249C0.985499 0.750343 0.817505 0.582349 0.817505 0.375354C0.817505 0.16836 0.985499 0.000366211 1.19249 0.000366211H6.81732C7.57581 0.000366211 8.19221 0.616863 8.19221 1.37535V3.62528C8.19221 3.83228 8.02422 4.00027 7.81723 4.00027Z"
              fill="#F27272"
            />
            <path
              d="M6.81731 10.5H4.81731C4.61032 10.5 4.44232 10.332 4.44232 10.125C4.44232 9.91804 4.61032 9.75005 4.81731 9.75005H6.81731C7.16181 9.75005 7.44223 9.46954 7.44223 9.12504V6.87511C7.44223 6.66812 7.61022 6.50012 7.81722 6.50012C8.02421 6.50012 8.1922 6.66812 8.1922 6.87511V9.12504C8.1922 9.88353 7.5758 10.5 6.81731 10.5Z"
              fill="#F27272"
            />
          </g>
          <defs>
            <clipPath id="clip0_2_825">
              <rect
                width="12"
                height="12"
                fill="white"
                transform="translate(0.192474)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { LOGOUT_USER } from "@/store/action-types";

export default {
  name: "ProfileInfo",
  computed: {
    ...mapGetters(["userData"]),
  },
  methods: {
    async logout() {
      await this.$store.dispatch(LOGOUT_USER);
      await this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.profile-info {
  width: 100%;
  padding: 20px 30px;
  border: 1px solid #f0f3fa;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__avatar {
    width: 64px;
    height: 64px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 50%;
    background-color: $lightBlue;
    margin-bottom: 14px;
    transition: opacity 0.2s linear;

    &:hover {
      opacity: 0.8;
    }
  }

  &__full_name {
    text-align: center;
    font-weight: 600;
    font-size: pxToRem(10);
    line-height: pxToRem(15);
    color: $text;
    margin-bottom: 1px;
  }

  &__registry_identifier {
    font-weight: 600;
    font-size: pxToRem(9);
    line-height: pxToRem(15);
    color: $action;
  }

  &__logout {
    margin-top: 20px;

    display: flex;
    align-items: center;
    cursor: pointer;
    transition: opacity 0.2s linear;

    &:hover {
      opacity: 0.7;
    }

    &-text {
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      color: $red;
    }

    &-icon {
      width: 12px;
      height: 12px;
      margin-left: 5px;
      display: flex;
      align-items: center;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
